import { setItem } from '@/utils/StorageManager'

export default {
  SET_CURRENT_STEP(state, payload) {
    state.currentStep = payload
    setItem('stateStepAddons', JSON.stringify(state))
  },

  SET_COSTUMER(state, payload) {
    state.customer = payload
    setItem('stateStepAddons', JSON.stringify(state))
  },

  SET_INFO_STEP(state, data) {
    for (var key in data) {
      state[key] = data[key]
    }

    setItem('stateStepAddons', JSON.stringify(state))
  },

  REMOVE_CART_ITEM(state, data){
    state['cartPackges'].splice(data, 1)
    setItem('stateStepAddons', JSON.stringify(state))
  },

  CLEAR_CART(state, data){
    state['cartPackges'] = []
    setItem('stateStepAddons', JSON.stringify(state))
  },

  SET_PROP_INFO_STEP(state, { prop, data }) {
    
    if(prop == 'cartPackges'){
      let hasItem = false
        for (let i = 0; i < state.cartPackges.length; i++)  {
          if(state.cartPackges[i].package.packSelected.id == data.package.packSelected.id){
            hasItem = true
            state.cartPackges[i].quantity = data.quantity
          }
        }  
      
      if(hasItem === false){
        state[prop].push(data)
      }
    } else {
      state[prop] = data
    }
    
    setItem('stateStepAddons', JSON.stringify(state))
  },

  SET_MODAL(state, { modalName, componentName }) {
    if (modalName == 'modalPlanDetails') {
      state.modalPlanDetails = true
      return
    }

    if (modalName && componentName) {
      state[modalName] = true
      state.componentOpenedInModal = componentName
      return
    }

    state.componentOpenedInModal = null
    state.modalPlanDetails = false
    state.modalpayment = false
    setItem('stateStepAddons', JSON.stringify(state))
  },

  CLOSE_MODAL(state) {
    state.componentOpenedInModal = null
    state.modalPlanDetails = false
    state.modalpayment = false
    setItem('stateStepAddons', JSON.stringify(state))
  },

  CLOSE_MODALa(state) {
    state.componentOpenedInModal = null
    state.modalPlanDetails = false
    state.modalpayment = false
    setItem('stateStepAddons', JSON.stringify(state))
  },

  RESET_STEP(state) {
    state.currentStep = 1
    state.modalPlanDetails = false
    state.modalpayment = false
    state.componentOpenedInModal = null
    state.maxAudience = 0
    state.maxEmailsIncluded = 0
    state.selectedPlanId = ''
    state.selectedPlanName = ''
    state.paymentPeriod = 1
    state.mount = 0

    localStorage.removeItem('stateStepAddons')
  },
}
